module.exports = __webpack_public_path__ + "img/spin_btn.6af0908b.png";